module.exports = __webpack_public_path__ + "img/Apple_icon.6323d50b.png";